// @flow
import React from 'react';
import { get } from 'lodash';

import { t } from 'Src/i18n';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { Spinner } from 'Components/frameworks/spinner/Spinner.jsx';
import { Price } from 'Components/frameworks/price/Price.jsx';
import { Button } from 'Components/frameworks/button/Button.jsx';
import { type PriceType } from 'Components/widgets/cruise-booking/CruiseBooking.utils';

type Props = {
  config: CMSContent,
  loading: boolean,
  price: PriceType,
  onClick: (*) => void,
};

export const CruiseFooter = (props: Props) => {
  const { config, loading, price, onClick } = props;

  if (loading) {
    return typeof window !== 'undefined' ? (
      <div className="flex flex-col items-center justify-center" data-testid="cruiseBooking-loader">
        <p>{t('booking.loadingPrice')}</p>
        <Spinner size="small" color={COLORS.GRAY} />
      </div>
    ) : null;
  }

  return (
    <div className="flex flex-col items-center justify-center">
      <Price
        hasInitialPrice={false}
        {...get(config, 'price.format', {})}
        {...price}
        theme="ticket"
      />
      <Button
        className="mt-6"
        colorBg={COLORS.BOOKING}
        colorBorder={COLORS.BOOKING}
        iconRight={{ name: ICONS.ARROW_FORTH }}
        size="large"
        theme="formSubmit"
        onClick={onClick}
        type="button"
        trackingData={{
          categoryGA: 'resort',
          actionGA: 'cruiseForm',
          labelGA: 'checkPrices',
        }}
      >
        {t('booking.labelCTA')}
      </Button>
      <div
        data-testid="cruiseBookingForm-disclaimer"
        className="leading-normal max-w-full mt-6 text-base text-center text-gray-darker "
      >
        {t('booking.disclaimer')}
      </div>
    </div>
  );
};
